import { render, staticRenderFns } from "./AddDrug.vue?vue&type=template&id=3efb6910&scoped=true&"
import script from "./AddDrug.vue?vue&type=script&lang=js&"
export * from "./AddDrug.vue?vue&type=script&lang=js&"
import style0 from "./AddDrug.vue?vue&type=style&index=0&id=3efb6910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb6910",
  null
  
)

export default component.exports